@if (availableOnlineTypeList) {
  <p-select
    [appendTo]="'body'"
    (onChange)="onTypeChange($event)"
    [options]="availableOnlineTypeList"
    [(ngModel)]="availableOnline"
    [filter]="true"
    filterBy="label, value"
    [disabled]="disabled()"
    placeholder="Please select"
  >
  </p-select>
}
